import api from './api';

const movieTicketsService = {
  async getAdminAccounts(page = 1, limit = 20, search = '') {
    const response = await api.get('/movie-tickets/admin/accounts', {
      params: { page, limit, search }
    });
    return response.data;
  },

  async createAdminAccount(bilibiliUid, bilibiliUname = '') {
    const response = await api.post('/movie-tickets/admin/accounts', {
      bilibili_uid: bilibiliUid,
      bilibili_uname: bilibiliUname
    });
    return response.data;
  },

  async refreshAdminAccountProfiles(bilibiliUids = [], refreshAll = false) {
    const response = await api.post('/movie-tickets/admin/accounts/refresh-names', {
      bilibili_uids: bilibiliUids,
      refresh_all: refreshAll
    });
    return response.data;
  },

  async getAdminAccountTransactions(bilibiliUid, page = 1, limit = 20, filters = {}) {
    const response = await api.get(`/movie-tickets/admin/accounts/${bilibiliUid}/transactions`, {
      params: { page, limit, ...filters }
    });
    return response.data;
  },

  async getAdminWalletTransactions(walletId, page = 1, limit = 20, filters = {}) {
    const response = await api.get(`/movie-tickets/admin/wallets/${walletId}/transactions`, {
      params: { page, limit, ...filters }
    });
    return response.data;
  },

  async adjustAccountMovieTickets(bilibiliUid, movieTicketDelta, reason = '') {
    const response = await api.post(`/movie-tickets/admin/accounts/${bilibiliUid}/adjust`, {
      movie_ticket_delta: movieTicketDelta,
      reason
    });
    return response.data;
  },

  async previewImport(csv) {
    const response = await api.post('/movie-tickets/admin/import/preview', { csv });
    return response.data;
  },

  async commitImport(csv, reason = '') {
    const response = await api.post('/movie-tickets/admin/import/commit', { csv, reason });
    return response.data;
  },

  async settle() {
    const response = await api.post('/movie-tickets/admin/settle');
    return response.data;
  },

  async exportCsv(type = 'accounts', search = '') {
    const response = await api.get('/movie-tickets/admin/export', {
      params: { type, search },
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `movie-tickets-${type}-${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

export default movieTicketsService;
